import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getLoadingStatus(state) {
    return state.loader;
  },
  getModalMessage(state) {
    return state.message;
  },
  getMessageStatus(state) {
    return state.modalMessage;
  },
  getSearchPolicy(state) {
    return state.searchPolis;
  },
  getListBank: state => {
    const listBank = qoalaStorage.getItem('banks') ? parseIfJsonString(qoalaStorage.getItem('banks')) : state.listBank;
    if (!listBank) {
      return [];
    }
    if (listBank === 'undefined') {
      return [];
    }
    if (typeof listBank === 'string') {
      return JSON.parse(listBank);
    }
    return listBank;
  },
  getFirstTime: state => {
    const firsTime = qoalaStorage.getItem('activeFirstTime')
      ? parseIfJsonString(qoalaStorage.getItem('activeFirstTime'))
      : state.firstTime;
    if (firsTime === null) {
      return true;
    }
    return firsTime;
  },
  getPin: state => {
    return qoalaStorage.getItem('pin') ? parseIfJsonString(qoalaStorage.getItem('pin')) : state.pin;
  },
  getOTPStatus: state => {
    return qoalaStorage.getItem('otpStatus') ? parseIfJsonString(qoalaStorage.getItem('otpStatus')) : state.otpStatus;
  },
  getProfileView: state => state.profileView,
  getCalledOnce: state => state.calledOnce,
  getNotifHome: state => {
    const notifHome = qoalaStorage.getItem('notifHome')
      ? parseIfJsonString(qoalaStorage.getItem('notifHome'))
      : state.notifHome;
    if (notifHome) {
      return '';
    }
    if (notifHome === 'undefined') {
      return '';
    }
    if (typeof notifHome === 'string') {
      return JSON.parse(notifHome);
    }
    return notifHome;
  },
  getPdfLink: state => {
    return qoalaStorage.getItem('pdfLink') ? parseIfJsonString(qoalaStorage.getItem('pdfLink')) : state.pdfLink;
  },
  getA2hs: state => {
    return qoalaStorage.getItem('A2HS') ? parseIfJsonString(qoalaStorage.getItem('A2HS')) : state.a2hs;
  },
  getVolumeUp: state => state.volumeUp,
  getVolumeDown: state => state.volumeDown,
  getCountryCode: state => {
    return qoalaStorage.getItem('country') ? parseIfJsonString(qoalaStorage.getItem('country')) : state.countryCode;
  },
  getPickUpDates: state => state.pickUpDates,
  getAddress: state => state.addressData,
  getLoginData: state => {
    return qoalaStorage.getItem('loginData') ? parseIfJsonString(qoalaStorage.getItem('loginData')) : state.loginData;
  },
  getArticles: state => state.articles,
  getDetailArticle: state => {
    return qoalaStorage.getItem('detailArticle')
      ? parseIfJsonString(qoalaStorage.getItem('detailArticle'))
      : state.detailArticle;
  },
  getPromos: state => state.promos,
  // getUserPhone: state => state.userPhone,
  getPurchaseHistory: state => {
    const purchaseHistory = qoalaStorage.getItem('purchaseHistory')
      ? parseIfJsonString(qoalaStorage.getItem('purchaseHistory'))
      : state.purchaseHistory;
    if (typeof purchaseHistory === 'string') {
      return JSON.parse(purchaseHistory);
    }
    return purchaseHistory || [];
  },
  getDetailPromo: state => state.detailPromo,
  getActiveTransaction: state => {
    return qoalaStorage.getItem('activeTransaction')
      ? parseIfJsonString(qoalaStorage.getItem('activeTransaction'))
      : state.activeTransaction;
  },
  getInsurancePartner: state => {
    return state.insurancePartner || [];
  },
  getComparedProduct: state => {
    const comparedProduct = qoalaStorage.getItem('comparedProducts')
      ? parseIfJsonString(qoalaStorage.getItem('comparedProducts'))
      : state.comparedProduct;
    if (!comparedProduct) {
      return '';
    }
    if (comparedProduct === 'undefined') {
      return '';
    }
    if (typeof comparedProduct === 'string') {
      return JSON.parse(comparedProduct);
    }
    return comparedProduct;
  },
  getGuest: state => {
    const guest = qoalaStorage.getItem('guest') ? parseIfJsonString(qoalaStorage.getItem('guest')) : state.guest;
    if (!guest) {
      return '';
    }
    if (guest === 'undefined') {
      return '';
    }
    if (typeof guest === 'string') {
      return JSON.parse(guest);
    }
    return guest;
  },
  getTransactionHistory: state => {
    const transactionHistory = qoalaStorage.getItem('transactionHistory')
      ? parseIfJsonString(qoalaStorage.getItem('transactionHistory'))
      : state.transactionHistory;
    if (!transactionHistory) {
      return '';
    }
    if (transactionHistory === 'undefined') {
      return '';
    }
    if (typeof transactionHistory === 'string') {
      return JSON.parse(transactionHistory);
    }
    return transactionHistory;
  },
  getTransactionHistoryDetail: state => {
    const transactionDetail = qoalaStorage.getItem('transactionHistoryDetail')
      ? parseIfJsonString(qoalaStorage.getItem('transactionHistoryDetail'))
      : state.transactionHistoryDetail;
    if (!transactionDetail) {
      return '';
    }
    if (transactionDetail === 'undefined') {
      return '';
    }
    if (typeof transactionDetail === 'string') {
      return JSON.parse(transactionDetail);
    }
    return transactionDetail;
  },
  getSnapToken: state => {
    const snapToken = qoalaStorage.getItem('snapToken')
      ? parseIfJsonString(qoalaStorage.getItem('snapToken'))
      : state.snapToken;
    if (!snapToken) {
      return '';
    }
    if (snapToken === 'undefined') {
      return '';
    }
    if (typeof snapToken === 'string') {
      return JSON.parse(snapToken);
    }
    return snapToken;
  },
  getLocaleLanguage: state => {
    const localeLanguage = qoalaStorage.getItem('localeLanguage')
      ? parseIfJsonString(qoalaStorage.getItem('localeLanguage'))
      : state.localeLanguage;
    // Locale language get from LS and might be string.
    if (typeof localeLanguage === 'string') {
      return JSON.parse(localeLanguage);
    }
    return localeLanguage;
  }
};
